import { useMemo } from "react";

export const euro = new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

type PriceData = {
    customer_price?: number | null;
    price?: number | null;
    fromPrice?: number | null;
    hasFromPrice?: boolean;
};

export function useFormattedCustomerPrice(priceData: PriceData): string | null {
    return useMemo(() => {
        const { customer_price, price, fromPrice, hasFromPrice } = priceData;

        const cp =
            hasFromPrice && fromPrice != null ? fromPrice : customer_price ?? price;

        if (cp == null) return null;

        const str = euro.format(cp);
        return hasFromPrice && fromPrice != null ? `ab ${str}` : str;
    }, [
        priceData.customer_price,
        priceData.price,
        priceData.fromPrice,
        priceData.hasFromPrice,
    ]);
}